import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { formatMoney } from 'partner360/features/keyInitiatives/ui/helpers/formatMoney'
import { IFinancialTargetGapInitiative } from 'partner360/features/keyInitiatives/ui/keyInitiativesQuality/models'

interface IUseFinancialTableConfigParams {
  activeCurrency: string
  onEditInitiative: (initiative: TKeyInitiative) => void
}

export const useFinancialTableConfig = ({
  activeCurrency,
  onEditInitiative,
}: IUseFinancialTableConfigParams) => {
  const financialTargetGapColumns = useMemo<IColumn<IFinancialTargetGapInitiative>[]>(
    () => [
      {
        field: 'Name',
        title: TRANSLATION_KEYS.quality.details.name,
        titleRender: () => <Translation text={TRANSLATION_KEYS.quality.details.name} />,
        renderFunction: (item) => item.Name || '',
      },
      {
        field: 'incremental',
        title: TRANSLATION_KEYS.quality.details.incremental,
        titleRender: () => <Translation text={TRANSLATION_KEYS.quality.details.incremental} />,
        renderFunction: (item) => formatMoney(item.incremental, activeCurrency),
      },
    ],
    [activeCurrency]
  )

  const financialTargetGapRowActions = useMemo(
    () => [
      {
        id: 'edit',
        action: (row: IFinancialTargetGapInitiative) => onEditInitiative(row.initiative),
        title: 'Edit',
        icon: 'kbase kbase-edit kbase-sm',
      },
    ],
    [onEditInitiative]
  )

  return {
    financialTargetGapColumns,
    financialTargetGapRowActions,
  }
}
